// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedEnvelopeFilledSvg from "@fishx/icons-svg/es/asn/RedEnvelopeFilled";
import FishxIcon from '../components/FishxIcon';

var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeFilledSvg
  }));
};

RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
export default React.forwardRef(RedEnvelopeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedEnvelopeFilled.js
// module id = 3977
// module chunks = 0